module.exports = __webpack_public_path__ + "ad65a50811d095ab0fed83d9b2917555.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/squinty-9.png
// module id = 2209
// module chunks = 0